import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../../style/EditInstructionModal.css';

const CATEGORY_OPTIONS = {
    mountainSafety: 'Безопасность в горах',
    fireSafety: 'Пожарная безопасность',
    waterSafety: 'Безопасность на водных объектах',
    citizenSafety: 'Гражданская оборона'
};

const LANGUAGES = ['ru', 'en', 'kk']; // Поддерживаемые языки

const EditInstructionModal = ({ instruction, onClose, onUpdate }) => {
    const [categoryType, setCategoryType] = useState('');
    const [translations, setTranslations] = useState({
        ru: { title: '', text: '', link: '' },
        en: { title: '', text: '', link: '' },
        kk: { title: '', text: '', link: '' }
    });

    // Инициализация данных из переданной инструкции
    useEffect(() => {
        if (instruction) {
            setCategoryType(instruction.categoryType || '');
            setTranslations({
                ru: instruction.translations?.ru || { title: '', text: '', link: '' },
                en: instruction.translations?.en || { title: '', text: '', link: '' },
                kk: instruction.translations?.kk || { title: '', text: '', link: '' }
            });
        }
    }, [instruction]);

    const handleTranslationChange = (lang, field, value) => {
        setTranslations((prev) => ({
            ...prev,
            [lang]: {
                ...prev[lang],
                [field]: value
            }
        }));
    };

    const handleUpdate = () => {
        const data = {
            categoryType: categoryType || null,
            translations,
        };

        axios.put(`https://api.alertapp.kz/api/v1/instructions/${instruction._id}`, data, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`,
                'Content-Type': 'application/json',
            },
        })
            .then(response => {
                onUpdate(response.data); // Обновляем родительский компонент
                onClose(); // Закрываем модальное окно
            })
            .catch(error => console.error('Error updating instruction:', error));
    };

    return (
        <div className="modal">
            <div className="modal-content">
                <button className="close-button" onClick={onClose}>×</button>
                <h2>Редактировать памятку</h2>
                <select
                    value={categoryType}
                    onChange={(e) => setCategoryType(e.target.value)}
                >
                    <option value="" disabled>Выберите категорию</option>
                    {Object.entries(CATEGORY_OPTIONS).map(([value, label]) => (
                        <option key={value} value={value}>{label}</option>
                    ))}
                </select>

                <div className="translations-container">
                    {LANGUAGES.map((lang) => (
                        <div key={lang} className="translation-block">
                            <h3>Перевод на {lang.toUpperCase()}</h3>
                            <input
                                type="text"
                                placeholder={`Название (${lang.toUpperCase()})`}
                                value={translations[lang]?.title || ''}
                                onChange={(e) =>
                                    handleTranslationChange(lang, 'title', e.target.value)
                                }
                            />
                            <textarea
                                className="scrollable-textarea"
                                placeholder={`Текст (${lang.toUpperCase()})`}
                                value={translations[lang]?.text || ''}
                                onChange={(e) =>
                                    handleTranslationChange(lang, 'text', e.target.value)
                                }
                            />
                            <input
                                type="text"
                                placeholder={`Ссылка (${lang.toUpperCase()})`}
                                value={translations[lang]?.link || ''}
                                onChange={(e) =>
                                    handleTranslationChange(lang, 'link', e.target.value)
                                }
                            />
                        </div>
                    ))}
                </div>

                <button onClick={handleUpdate} className="submit-button">Сохранить</button>
            </div>
        </div>
    );
};

export default EditInstructionModal;
